import React from "react";
import { Check, Crown, ShieldCheck, Gift } from "lucide-react";
import { pricing, bonuses, comparison, RESERVE_URL } from "../mock";

export default function Pricing() {
  return (
    <section id="tarifs" className="relative py-20 md:py-28">
      <div className="relative mx-auto max-w-7xl px-5">
        {/* Bonuses */}
        <div className="text-center reveal max-w-3xl mx-auto">
          <span className="kicker">Et ce n'est pas tout</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            3 bonus exclusifs{" "}
            <span className="gold-gradient-text">offerts</span>
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {bonuses.map((b) => (
            <div key={b.tag} className="reveal glass card-hover rounded-3xl p-7">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 text-aqua text-sm">
                  <Gift className="h-4 w-4" /> {b.tag}
                </span>
                <span className="text-xs text-white/45 line-through decoration-gold/60">Valeur {b.value}</span>
              </div>
              <h3 className="font-display text-lg text-white mt-4 leading-snug">{b.title}</h3>
              <p className="text-sm text-white/60 mt-3 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* Pricing */}
        <div className="mt-24 text-center reveal max-w-3xl mx-auto">
          <span className="kicker">L'investissement</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Choisis ta{" "}
            <span className="gold-gradient-text">formule</span>
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {pricing.map((p) => (
            <div
              key={p.name}
              className={`reveal rounded-[2rem] p-8 md:p-10 relative card-hover ${
                p.popular ? "glass-strong" : "glass"
              }`}
            >
              {p.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 btn-gold px-4 py-1.5 text-xs">
                  <Crown className="h-3.5 w-3.5" /> Populaire
                </span>
              )}
              <div className="text-sm uppercase tracking-widest text-aqua">{p.name}</div>
              <div className="font-display text-xl text-white/80 mt-1">{p.subtitle}</div>
              <ul className="mt-7 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-white/80 text-[15px]">
                    <span className="mt-1 grid place-items-center h-5 w-5 rounded-full bg-[#e8c874]/15 text-gold shrink-0">
                      <Check className="h-3 w-3" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href={RESERVE_URL}
                target="_blank"
                rel="noreferrer"
                className={`mt-8 w-full py-4 inline-block text-center ${p.popular ? "btn-gold" : "btn-ghost"}`}
              >
                {p.popular ? "Je choisis le VIP" : "Je m'inscris"}
              </a>
            </div>
          ))}
        </div>

        {/* Guarantee */}
        <div className="mt-14 reveal glass rounded-3xl p-8 flex flex-col md:flex-row items-center gap-6 max-w-4xl mx-auto">
          <span className="grid place-items-center h-16 w-16 rounded-full bg-[#e8c874]/12 text-gold shrink-0">
            <ShieldCheck className="h-8 w-8" />
          </span>
          <div className="text-center md:text-left">
            <h3 className="font-display text-xl text-white">Garantie « satisfait(e) ou remboursé(e) »</h3>
            <p className="text-white/60 text-sm mt-2">
              14 jours pour explorer le module 1. Si cela ne te correspond pas, tu es
              remboursé(e) intégralement en 48h. 0 risque.
            </p>
          </div>
        </div>

        {/* Comparison */}
        <div className="mt-24">
          <div className="text-center reveal max-w-3xl mx-auto">
            <span className="kicker">En quoi c'est différent</span>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-white mt-3">
              D'autres solutions existent, mais…
            </h2>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {comparison.map((c) => (
              <div key={c.title} className="reveal glass card-hover rounded-3xl p-7">
                <h3 className="font-display text-xl text-gold">{c.title}</h3>
                <p className="text-sm text-white/65 mt-3 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
